export default {"src":"/_next/static/media/report-active.cebba1d9.svg","height":17,"width":16};